import axios from "axios";
import { store } from "../store"; // Import Redux store
import { logout, setToken, setRefreshToken, setParkPassToken, setParkPassRefreshToken } from "../store/userSlice";
import { API_URL } from "../constants";
import { refreshParkPassTokenAPI } from "../api/parkpassAuth";

export const getToken = () => store.getState().user.token;

export const getParkPassToken = () => store.getState().user.parkpass_token;

export const setTokenInStore = (token) => store.dispatch(setToken(token));

export const setRefreshTokenInStore = (refresh_token) =>
  store.dispatch(setRefreshToken(refresh_token));

export const setParkPassTokenInStore = (token) => store.dispatch(setParkPassToken(token));

export const setParkPassRefreshTokenInStore = (refresh_token) =>
  store.dispatch(setParkPassRefreshToken(refresh_token));

export const clearUserSession = () => store.dispatch(logout());

export const refreshToken = async () => {
  try {
    const refreshToken = localStorage.getItem("refresh_token");
    const response = await axios.post(
      `${API_URL}refresh-token`,
      { refresh_token: refreshToken },
      {
        headers: {
          "Content-Type": "application/json",
          "X-APP-KEY": process.env.REACT_APP_API_KEY,
          "X-From": "portal",
        },
      }
    );
    const { token, refresh_token } = response.data;
    setTokenInStore(token);
    setRefreshTokenInStore(refresh_token);
    return token;
  } catch (error) {
    clearUserSession();
    throw error;
  }
};

export const refreshParkPassToken = async () => {
  try {
    const parkpassRefreshToken = localStorage.getItem("parkpass_refresh_token");
    if (!parkpassRefreshToken) {
      throw new Error("No ParkPass refresh token available");
    }
    
    const response = await refreshParkPassTokenAPI(parkpassRefreshToken);
    const { access_token, refresh_token } = response;
    
    setParkPassTokenInStore(access_token);
    setParkPassRefreshTokenInStore(refresh_token);
    
    return access_token;
  } catch (error) {
    clearUserSession();
    throw error;
  }
};
